import * as ResultsProcessStatementTable from './ResultsProcessStatementTable';
import * as ResultsTable from './ResultsTable';

import { FormatDate } from './FormatDate';


export const RenderTableConfig = {
  ResultsProcessStatementTable,
  ResultsTable,

  FormatDate,
};
